import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Menu, X } from 'lucide-react';
import hlogo from "../assests/logo_header.png"
import logo from "../assests/nav-logo.png"
const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  // Check if current page is home page
  const isHomePage = location.pathname === '/';

  const navItems = [
    { name: 'Products', href: '/products' },
    { name: 'About Us', href: '/about' },
    { name: 'Contact Us', href: '/contact-us' }
  ];

  // Dynamic navbar classes based on page
  const navbarClasses = isHomePage 
    ? "bg-transparent absolute top-0 left-0 right-0 z-50" 
    : "bg-white shadow-sm border-b border-gray-100 sticky top-0 z-50";

  const navbarVariants = {
    hidden: { y: -100, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.6,
        ease: "easeOut",
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { y: -20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { duration: 0.4 }
    }
  };

  const logoHoverVariants = {
    hover: {
      scale: 1.05,
      transition: { duration: 0.3 }
    }
  };

  const mobileMenuVariants = {
    closed: {
      opacity: 0,
      height: 0,
      transition: {
        duration: 0.3,
        ease: "easeInOut"
      }
    },
    open: {
      opacity: 1,
      height: "auto",
      transition: {
        duration: 0.3,
        ease: "easeInOut",
        staggerChildren: 0.1
      }
    }
  };

  const mobileItemVariants = {
    closed: { x: -20, opacity: 0 },
    open: {
      x: 0,
      opacity: 1,
      transition: { duration: 0.3 }
    }
  };

  // Function to check if current route is active
  const isActiveRoute = (href) => {
    return location.pathname === href;
  };

  return (
    <motion.nav 
      className={navbarClasses}
      variants={navbarVariants}
      initial="hidden"
      animate="visible"
    >
     <div className="mx-auto px-4 sm:px-6 md:px-12 lg:px-24">
        <div className="flex justify-between items-center h-16">
          {/* Logo Section */}
       {/* Logo Section */}
<motion.div 
  className="flex items-center space-x-3"
  variants={itemVariants}
  whileHover="hover"
>
  <Link to="/" className="flex items-center space-x-3">
    <motion.div 
      className="h-12"
      variants={logoHoverVariants}
    >
      <img 
        src={isHomePage ? hlogo : logo} 
        alt="Vidyut Systems Logo" 
        className="h-full w-auto object-contain" 
      />
    </motion.div>
  </Link>
</motion.div>

          {/* Desktop Navigation Links */}
          <motion.div 
            className="hidden md:flex items-center space-x-8"
            variants={itemVariants}
          >
            {navItems.map((item, index) => (
              <motion.div key={item.name} className="relative">
                <Link
                  to={item.href}
                  className={`font-semibold text-base transition-colors duration-200 relative ${
                    isHomePage ? 'text-white hover:text-white/80' : 'text-black hover:text-black/70'
                  }`}
                >
                  <motion.span
                    whileHover={{ 
                      scale: 1.05,
                      transition: { duration: 0.2 }
                    }}
                  >
                    {item.name}
                  </motion.span>
                  <motion.div
                    className={`absolute bottom-0 left-0 h-0.5 ${
                      isHomePage ? 'bg-white' : 'bg-black'
                    } ${isActiveRoute(item.href) ? 'w-full' : 'w-0'}`}
                    whileHover={{
                      width: "100%",
                      transition: { duration: 0.3 }
                    }}
                  />
                </Link>
              </motion.div>
            ))}
          </motion.div>

          {/* Mobile Menu Button */}
          <motion.div 
            className="md:hidden"
            variants={itemVariants}
          >
            <motion.button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className={`focus:outline-none transition-colors duration-200 ${
                isHomePage ? 'text-white hover:text-white/80' : 'text-black hover:text-black/70'
              }`}
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.95 }}
            >
              {isMobileMenuOpen ? (
                <X className="h-6 w-6" />
              ) : (
                <Menu className="h-6 w-6" />
              )}
            </motion.button>
          </motion.div>
        </div>

        {/* Mobile Navigation Menu */}
        <motion.div
          className="md:hidden overflow-hidden"
          variants={mobileMenuVariants}
          animate={isMobileMenuOpen ? "open" : "closed"}
          initial="closed"
        >
          {/* Full width background container for mobile menu */}
          <div className="bg-white shadow-lg border-t border-gray-200 mt-2">
            <div className="py-4 space-y-1">
              {navItems.map((item, index) => (
                <motion.div key={item.name} variants={mobileItemVariants}>
                  <Link
                    to={item.href}
                    className={`block font-medium text-sm py-3 px-6 transition-all duration-200 ${
                      isActiveRoute(item.href)
                        ? 'text-white bg-blue-500 border-l-4 border-blue-800'
                        : 'text-gray-700 hover:text-blue-600 hover:bg-gray-50 hover:border-l-4 hover:border-blue-200'
                    }`}
                    onClick={() => setIsMobileMenuOpen(false)}
                  >
                    <motion.span
                      whileHover={{ 
                        x: 5,
                        transition: { duration: 0.2 }
                      }}
                      whileTap={{ scale: 0.98 }}
                    >
                      {item.name}
                    </motion.span>
                  </Link>
                </motion.div>
              ))}
            </div>
          </div>
        </motion.div>
      </div>
    </motion.nav>
  );
};

export default Navbar;